import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { ReactNode } from 'react';

const CardContainer = styled.div`
    height: 15.6rem;
    min-width: 36rem;
    max-width: 52rem;
    width: 100%;
    background: #fff;
    border: 1px solid ${({ theme }) => theme.colors.black[300]};
    border-radius: 12px;
    padding: 1.2rem;
    display: flex;
    gap: 1.6rem;

    @media (min-width: 1900px) {
        height: 16.8rem;
    }
`;

const InformationContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0.6rem 0;
    padding-right: 0.4rem; // in order to break text to lines
`;

const Title = styled(Typography)`
    line-height: 2.186rem;
    margin-bottom: 0.8rem;
`;

const Description = styled(Typography)`
    line-height: 2.24rem;
`;

interface IProps {
    image: ReactNode;
    title: string;
    description: ReactNode;
    button: ReactNode;
}

function SuggestionCard({ title, description, button, image }: IProps) {
    return (
        <CardContainer>
            {image}
            <InformationContainer>
                <div>
                    <Title variant="h4">{title}</Title>
                    <Description variant="body2">{description}</Description>
                </div>
                {button}
            </InformationContainer>
        </CardContainer>
    );
}

export default SuggestionCard;
